module.exports = __webpack_public_path__ + "img/cjwt@2x.643ad8f5.png";